export default __webpack_public_path__ + "static/media/baycruisenew.37989b74.jpg";